import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { UserDataPayload, UserDataResponse } from "@/types/interface/user";

async function createUser(payload: UserDataPayload) {
  return await http.post<APIResponse<UserDataResponse>>("user/create", payload);
}

async function updateUser(idUser = '', payload: UserDataPayload) {
  return await http.patch<APIResponse<UserDataResponse>>(`user/update?id=${idUser}`, payload);
}

async function getUser(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<UserDataResponse>>(`user?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findUser(idUser = "") {
  return await http.get<APIResponse<UserDataResponse>>(`user/detail?id=${idUser}`);
}

async function deleteUser(idUser = "") {
  return await http.delete<APIResponse<UserDataResponse>>(`user/delete?id=${idUser}`);
}

export default {
  createUser,
  updateUser,
  getUser,
  findUser,
  deleteUser
};